import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff2d55', // Vibrant red
      light: '#ff5c7f',
      dark: '#c5002f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#00e5ff', // Cyan
      light: '#6effff',
      dark: '#00b2cc',
    },
    background: {
      default: '#0a0a0f',
      paper: '#121218',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 20px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(255, 45, 85, 0.3)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 6px 16px rgba(255, 45, 85, 0.4)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(145deg, #121218 0%, #1a1a24 100%)',
          border: '1px solid rgba(255, 255, 255, 0.05)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#121218',
          border: '1px solid rgba(255, 255, 255, 0.05)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.1)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255, 45, 85, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ff2d55',
            },
          },
        },
      },
    },
  },
});

export const globalStyles = {
  // Custom scrollbar
  '@global': {
    '*::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
    },
    '*::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.05)',
    },
    '*::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 45, 85, 0.5)',
      borderRadius: '4px',
      '&:hover': {
        background: '#ff2d55',
      },
    },
  },
  // Animation keyframes
  '@keyframes gradientBG': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    },
  },
  // Tooltip styles
  tooltip: {
    backgroundColor: '#121218',
    color: '#ffffff',
    fontSize: '0.8rem',
    padding: '8px 12px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
  },
  // Glass morphism effect
  glass: {
    background: 'rgba(18, 18, 24, 0.7)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
};
